import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link, useLocation } from 'react-router-dom'
import { useCartContext } from '../context/cart_context'
import axios from 'axios'
import { Layout } from '../components/page-layout'

const FROM_ADDRESS = {
  firstName: 'Sam',
  lastName: 'Wilson',
  streetAddress: '45 L St SW',
  city: 'Washington',
  state: 'DC',
  ZIPCode: '20024'
}
const PACKAGE_DESCRIPTION = {
  mailClass: 'USPS_GROUND_ADVANTAGE',
  rateIndicator: 'SP',
  weightUOM: 'lb',
  weight: 0.5,
  dimensionsUOM: 'in',
  length: 9,
  height: 6,
  width: 0.25,
  processingCategory: 'NONSTANDARD',
  mailingDate: '2024-10-05',
  extraServices: [],
  destinationEntryFacilityType: 'NONE'
}

const SuccessfulPayment = () => {
  const { clearCart } = useCartContext()
  const [labelUrl, setLabelUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const location = useLocation()

  useEffect(() => {
    clearCart()
    // Get session_id from URL
    const params = new URLSearchParams(location.search)
    const session_id = params.get('session_id')
    if (session_id) {
      setLoading(true)
      const fetchLabel = async () => {
        try {
          const res = await axios.post('/api/checkout/shipping/label', {
            session_id,
            fromAddress: FROM_ADDRESS,
            packageDescription: PACKAGE_DESCRIPTION
          }, { responseType: 'blob' })
          // Create a blob URL for the PDF
          const url = URL.createObjectURL(res.data)
          setLabelUrl(url)
        } catch (err) {
          console.error('Error fetching shipping label:', err)
          setError('Could not fetch shipping label.')
        } finally {
          setLoading(false)
        }
      }
      fetchLabel()
    }
    //eslint-disable-next-line
  }, [])

  return (
    <Layout showCommonFooter={true}>
    <Wrapper className='page-100'>
      <section>
        <h1>Thank you</h1>
        <h3>Payment is completed</h3>
        <Link to='/' className='btn'>
          back to home page
        </Link>
          {loading && <p>Loading shipping label...</p>}
          {error && <p style={{ color: 'red' }}>{error}</p>}
          {labelUrl && (
            <>
              <h4>Your Shipping Label:</h4>
              <iframe src={labelUrl} width="400" height="600" title="Shipping Label" />
              <br />
              <a href={labelUrl} download="shipping_label.pdf" className="btn">Download Label</a>
            </>
          )}
      </section>
    </Wrapper>
    </Layout>
  )
}

export default SuccessfulPayment

const Wrapper = styled.main`
  background: var(--clr-primary-10);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  h1 {
    font-size: 8rem;
    margin-bottom: 1rem;
  }
  h3 {
    text-transform: none;
    margin-bottom: 2rem;
  }
`
